module.exports = __webpack_public_path__ + "static/media/1.bed49f37.jpg";